<template>
  <div class="center">
    <div class="mb-12 mt-8">
      <div class="text-center">
        <h1 class="text-3xl font-bold mb-4 ot-anim my-20">
          {{ $t("homePage.title") }}
        </h1>

        <div class="flex flex-col gap-4">
          <p
            class="text-gray-500 ot-anim ot-line mx-auto text-left"
            :key="paragraph"
            v-for="paragraph in $i18n.messages[$i18n.locale].homePage
              .paragraphs"
          >
            {{ paragraph }}
          </p>
        </div>
      </div>
    </div>

    <div
      class="grid grid-cols-1 md:grid-cols-2 text-sm gap-4 max-w-3xl mx-auto"
    >
      <RouterLink
        v-for="(link, i) in pages"
        :key="i"
        :to="link.to"
        class="relative bg-white rounded-lg focus:outline-none transition-shadow group hover:no-underline hover:text-current text-left border-0 shadow-md hover:shadow-xl focus:ring-2 focus:ring-offset-gray-100 focus:ring-secondary hover:ring-2 hover:ring-offset-gray-100 hover:ring-secondary"
      >
        <img
          :src="`${publicPath}img/${link.image}`"
          :alt="`${link.name}: ${link.text}`"
          class="rounded-lg w-full"
        />

        <div class="z-20 absolute inset-0">
          <div :class="paddingTopClass" class="w-1/2 p-8">
            <h3 class="font-semibold text-base leading-snug uppercase">
              {{ $t(link.name) }}
            </h3>
            <p class="text-gray-600 text-sm mt-2">
              {{ $t(link.text) }}
            </p>
          </div>
        </div>
      </RouterLink>
    </div>

    <div class="mb-12 mt-8">
      <div class="text-left">
        <p class="text-gray-500 ot-anim ot-line mx-auto">
          {{ $t("homePage.bottomText") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import domains from "@/assets/data/domains";
import { regionsToCountries } from "../utils/helpers";
const countries = regionsToCountries();

export default {
  data() {
    return {
      publicPath: window.data_vis_uri || process.env.BASE_URL,
      locale: this.$i18n.locale,
    };
  },
  computed: {
    dataset() {
      return this.$route.params.dataset || "girls";
    },
    domainId() {
      return domains.find((e) => !e[`disabled_${this.dataset}`]).id;
    },
    iso() {
      // the order of preference for the country iso is:
      // 1 - URL param
      // 2 - localStorage value
      // 3 - Random
      return this.$route.params.iso || localStorage.getItem("iso") || "CMR";
    },
    regionId() {
      // // first region on the list
      // const regionId = regions[0].id;
      // // the one on the route, or if there's none, the first one on the list of regions
      // return this.$route.params.regionId || regionId;
      return (
        this.$route.params.regionId ||
        countries[this.iso] ||
        "sub-saharan-africa"
      );
    },
    pages() {
      // const params = { domainId: this.domainId };

      return [
        {
          name: "homePage.cards.girls",
          text: "homePage.cards.subtitleGirls",
          to: { name: "risk", params: { dataset: "girls" } },
          image: "girls.jpg",
        },
        {
          name: "homePage.cards.boys",
          text: "homePage.cards.subtitleBoys",
          to: { name: "risk", params: { dataset: "boys" } },
          image: "boys.png",
        },
        // {
        //   name: "Policy checklist",
        //   text: "Explore the adolescent-focused policies in the countries of the world",
        //   to: {
        //     name: "policy",
        //     params: { ...params, regionId: this.regionId },
        //   },
        //   image: "card_policy.svg",
        // },
      ];
    },
    paddingTopClass() {
      // Check the current language to adjust padding
      const mapPadding = {
        en: "pt-12",
        fr: "pt-10",
        es: "pt-12",
        pt: "pt-10"
      }
      return mapPadding[this.$i18n.locale];
    },
  },
};
</script>
